import { makeStyles } from '@material-ui/core/styles';

const useStylesPaymentOption = makeStyles((theme) => ({
  summaryContentPayment: {
    backgroundColor: 'white',
    padding: '40px 40px 0',
    width: '100%',
    '&.Mui-focused': {
      backgroundColor: 'white',
    },
    '& .MuiAccordionSummary-content': {
      margin: '0',
    },
    [theme.breakpoints.down('lg')]: {
      padding: '30px 20px 0',
    },
  },
  amountPayment: {
    fontFamily: theme.typography.proxima.semiBold,
    color: theme.palette.blue1,
    fontSize: theme.typography.pxToRem(24),
    paddingRight: '24px',
    textAlign: 'end',
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(20),
      textAlign: 'left',
      paddingTop: '8px',
    },
  },
  customInputPayment: {
    paddingRight: '24px',
    textAlign: 'end',
    '& .MuiFormHelperText-root, & .MuiFormHelperText-root.Mui-error': {
      fontSize: theme.typography.pxToRem(10),
      textAlign: 'right',
    },
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
      '& .MuiFormHelperText-root, & .MuiFormHelperText-root.Mui-error': {
        fontSize: theme.typography.pxToRem(10),
        textAlign: 'left',
      },
    },
  },
}));

export default useStylesPaymentOption;
